import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { BaseComponent } from '../../../core/models/base-component.model';
import { INotificationService } from '../../services/inotification.service';
import { BaseControl } from '../../ui/controls/base-control.model';
import { UrlControl } from '../../ui/controls/url-control.model';
import { GridLayoutModule } from '@progress/kendo-angular-layout';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-url-field',
    imports: [GridLayoutModule, TextBoxModule, FontAwesomeModule, TranslateModule, FormsModule],
    templateUrl: './url-field.component.html',
    styleUrls: ['./url-field.component.css']
})
export class UrlFieldComponent extends BaseComponent implements OnInit {

  @Input() control: BaseControl;

  urlControl: UrlControl;
  icon: IconDefinition;

  constructor(private notificationService: INotificationService) { super(); }

  ngOnInit() {
    this.urlControl = this.control as UrlControl;
    this.icon = faGlobe;
  }

  launch(): void {
    var e = window.event;
    e?.preventDefault();

    var url = this.urlControl.value;

    if (url == null || url.length == 0) {
      this.notificationService.show({ title: "No URL present", type: "info" });
      return;
    }

    var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    var regex = new RegExp(expression);

    if (url.match(regex)) {
      // launch url
      window.open(url, "_blank");
    } else {
      this.notificationService.show({ title: "Not a valid URL.", type: "error" });
      return;
    }

  }

}
